import { resultsOptions } from "@jetblue/dotcom-api/vertex-search";
import { useQuery } from "@tanstack/react-query";
import type { SyntheticEvent } from "react";
import { useCallback, useState } from "react";

const API_URL = "/api/vertex-search";

export type UseVertexSearchProperties = {
  /**
   * Search query string for vertex search API.
   */
  initialQuery: string;
};
export const useVertexSearch = ({
  initialQuery,
}: UseVertexSearchProperties) => {
  const [query, setQuery] = useState(initialQuery);

  const handleQueryChange = useCallback((newQuery: string | undefined) => {
    setQuery(newQuery ?? "");
  }, []);

  const response = useQuery({
    ...resultsOptions({ query: query }, API_URL),
    enabled: Boolean(query),
  });

  const handleSubmit = useCallback(
    (event: SyntheticEvent<HTMLFormElement>) => {
      event.preventDefault();
      const isValid = Boolean(query);
      if (!isValid) {
        return;
      }
    },
    [query],
  );

  return {
    handleSubmit,
    response,
    setQuery: handleQueryChange,
  };
};
